export enum Subject {
  ApplyToJoin = 'Apply To Join',
  ContactUs = 'Contact Us',
}
